/* eslint-disable indent */
/* eslint-disable prettier/prettier */
// import { Tooltip } from '@material-ui/core'
import React, { useState } from 'react'
import { AiOutlineQuestion } from 'react-icons/ai'

import { IoMdEye, IoMdEyeOff } from 'react-icons/io'
import { MdSearch } from 'react-icons/md'

import Tooltip from '../ToolTip'

import {
  Container,
  Label,
  InputContainer,
  Prefix,
  InputElement,
  Status,
  Error,
  HidePassword,
  IconContainer,
  InputTextAreaElement,
  ToolTipContent,
  Button,
  Loading
} from './styles'
import { Oval } from '@agney/react-loading'

export interface ErrorTypes {
  id: number
  message: string
}
export interface InputProps {
  label?: string | boolean | any
  placeholder?: string
  value?: string | number | readonly string[] | undefined
  defaultValue?: string
  type?: string
  onChange?: any
  onBlur?: any
  status?: number
  prefix?: string
  error?: string
  textPrefix?: string
  light?: boolean
  isPassword?: boolean
  onKeyDown?: any
  disable?: boolean
  disableOpacity?: string
  icon?: any
  isPasswordWithoutIcon?: boolean
  isSearch?: any
  isRequired?: boolean | string
  ref?: any
  onKeyPress?: any
  autocomplete?: string
  hasToolTip?: boolean
  titleToolTip?: any
  borderError?: boolean
  maxLength?: number
  height?: string
  isLight?: boolean
  tooltipSeccondary?: boolean
  isDark?: boolean
  style?: any
  styleArea?: any
  styleLabel?: any
  max?: string
  searchAction?: any
  min?: any
  stylesTitle?: any
  smallTooltip?: boolean
  onClick?: () => void
  button?: any
  buttonAction?: () => void
  disableValue?: boolean
  warning?: string
  minHeight?: string
  prefixEnd?: string
  loading?: boolean
  loadingValue?: boolean
  reference?: React.MutableRefObject<HTMLDivElement | null>
}

// Status 1 -> Verificado
// Status 2 -> Erro

const Input: React.FC<InputProps> = props => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <Container
      style={props.style}
      disable={props.disable}
      disableOpacity={props.disableOpacity}
    >
      <Label label={props.label} style={props.stylesTitle}>
        {props.label}
        {props.isRequired && <span>*</span>}

        {props.hasToolTip && (
          <Tooltip content={props.titleToolTip}>
            <ToolTipContent smallTooltip={props.smallTooltip}>
              <nav className="checkout_builder_contrast_color">
                <AiOutlineQuestion className="checkout_builder_font_color" />
              </nav>
            </ToolTipContent>
          </Tooltip>
        )}
      </Label>
      {props.loadingValue !== undefined && props.loadingValue ? (
        <></>
      ) : (
        <InputContainer
          light={props.light}
          isLight={props.isLight}
          ref={props.reference}
        >
          {props.prefix && (
            <Prefix className="checkout_builder_contrast_color">
              {props.prefix || '+55'}
            </Prefix>
          )}
          {props.textPrefix && (
            <Prefix
              className="checkout_builder_contrast_color"
              id="Prefix"
              style={{ color: 'var(--white)' }}
            >
              {props.textPrefix}
            </Prefix>
          )}
          <InputElement
            type={
              (props.isPassword && !isVisible) ||
              (props.isPasswordWithoutIcon && !isVisible)
                ? 'password'
                : props.type || 'text'
            }
            placeholder={props.placeholder}
            onClick={props.onClick}
            isLight={props.isLight}
            value={props.value || ''}
            defaultValue={props.defaultValue}
            onChange={props.onChange}
            onBlur={props.onBlur}
            onKeyDown={props.onKeyDown}
            disabled={props.disable || props.disableValue}
            readOnly={props.disable}
            icon={props.icon}
            ref={props.ref}
            min={props.min}
            onKeyPress={props.onKeyPress}
            autoComplete={props.autocomplete}
            isPrefix={props.prefix !== undefined}
            borderError={props.borderError}
            maxLength={props.maxLength}
            style={props.styleLabel}
            max={props.max}
            disableValue={props.disableValue}
          />
          {props.button !== undefined && (
            <Button onClick={props.buttonAction}>{props.button}</Button>
          )}
          {props.status !== undefined && props.status !== 0 && (
            <Status light={props.light} status={props.status} />
          )}
          {props.isPassword && (
            <HidePassword
              onClick={() => setIsVisible(!isVisible)}
              withoutIcon={props.isPasswordWithoutIcon}
            >
              {!isVisible ? (
                <IoMdEyeOff size={18} color="var(--primary)" />
              ) : (
                <IoMdEye size={18} color="var(--primary)" />
              )}
            </HidePassword>
          )}

          {props.prefixEnd !== undefined && (
            <section>{props.prefixEnd}</section>
          )}

          {props?.loading && (
            <Loading>
              <Oval />
            </Loading>
          )}

          <IconContainer isSearch={props.isSearch}>
            {props.isSearch && (
              <MdSearch
                size={16}
                color="var(--primary)"
                style={{ cursor: 'pointer' }}
                onClick={props.searchAction}
              />
            )}
            {props.icon}
          </IconContainer>
        </InputContainer>
      )}
      {props.error && typeof props.error !== 'number' && (
        <Error>{props.error}</Error>
      )}
    </Container>
  )
}

export default Input

export const InputArea: React.FC<InputProps> = props => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Tab') {
      event.preventDefault()

      const textarea = event.currentTarget
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const value =
        textarea.value.substring(0, start) +
        '\t' +
        textarea.value.substring(end)

      textarea.value = value

      textarea.selectionStart = textarea.selectionEnd = start + 1

      if (props.onChange) {
        props.onChange({
          ...event,
          target: {
            ...event.target,
            value
          }
        })
      }
    }
  }

  return (
    <Container style={props.styleArea} disable={props.disable}>
      <Label label={props.label}>
        {props.label}
        {props.isRequired && <span>*</span>}
      </Label>

      <InputContainer
        light={props.light}
        isTextArea
        className="textAreaConteiner"
        height={props.height}
      >
        {props.prefix && <Prefix>+55</Prefix>}
        <InputTextAreaElement
          placeholder={props.placeholder}
          value={props.value}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onKeyDown={props.onKeyDown ? props.onKeyDown : handleKeyDown}
          disabled={props.disable}
          readOnly={props.disable}
          maxLength={props.maxLength}
          style={{ minHeight: props.minHeight ? props.minHeight : '' }}
        />
        {props.status !== undefined && props.status !== 0 && (
          <Status light={props.light} status={props.status} />
        )}
        <IconContainer>{props.icon}</IconContainer>
      </InputContainer>
      {props.error && typeof props.error !== 'number' && (
        <Error>{props.error}</Error>
      )}
      {props.warning !== undefined && <p>{props.warning}</p>}
    </Container>
  )
}
